const rootUrl = 'users';
const authUrl = `${rootUrl}/auth`;
const refreshUrl = `${rootUrl}/refresh`;
const confirmUrl = `${rootUrl}/confirm`;
const requestNewCodeUrl = `${rootUrl}/request-new-code`;
const logoutUrl = `${rootUrl}/logout`;

export default { authUrl, refreshUrl, confirmUrl, requestNewCodeUrl, logoutUrl };
